export default __webpack_public_path__ + "static/englet-3-9e8333c4801b065a5379e80ff7a6335a.jpg";